import React from "react";
import styled, { css } from "styled-components";
import { motion } from "framer-motion";
import LoadingDots from "./LoadingDots";

const Wrapper = styled.div<{ $isFullscreen?: boolean }>`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  flex: 1 1 auto;

  ${(props) =>
    props.$isFullscreen &&
    css`
      position: fixed;
      top: 0;
      left: 0;
      width: 100vw;
      height: 100vh;
    `}
`;

interface Props {
  fullscreen?: boolean;
  fadeIn?: boolean;
}

const Loading: React.FC<Props> = ({ fullscreen, fadeIn, ...props }) => (
  <Wrapper $isFullscreen={fullscreen} {...props}>
    {fadeIn ? (
      <motion.div
        animate={{ opacity: 1 }}
        initial={{ opacity: 0.2 }}
        transition={{
          duration: 0.33,
          delay: 2,
        }}
      >
        <LoadingDots />
      </motion.div>
    ) : (
      <LoadingDots />
    )}
  </Wrapper>
);

export default Loading;
